/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable max-len */
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// eslint-disable-next-line import/no-cycle
import {
  verifyId,
  verifyIdPrefilled,
  resetIdVerificationResult,
  registerAccount,
  updateErrorMessage,
  updateHasErroredFromVerifyIdPrefilled,
  shadowRegisterAccount,
  handleIdUploadSuccess,
  ssoExistingContact,
  verifySso,
  updateCaseContact,
  ssoContactPrefilledId,
  updateIsVerifyIdPrefilledError,
} from './actions';

import {
  selectIdVerificationResult,
  selectIdVerificationErrorMessage,
  selectDirectorList,
  selectCanVerifyIdUsingPrefilledDetails,
  selectAbn,
  selectHasErroredFromVerifyIdPrefilled,
  selectInvitedStatus,
  selectIsTrust,
  selectTrusteeNames,
  selectMainRegistrationMode,
  selectWorkflowMIsIdVerificationAttemptsMaxed,
  selectShadowRegisteredAccountId,
  selectPEPStatus,
  selectIsPotentialAMLIdentified,
  selectMainPortal,
  selectUserJourneyAccountType,
  selectIsVerifyIdPrefilledError,
} from '../../../selectors';
import IdVerification from './Component';
import { myNameIsNotHere } from './constants';

const mapStateToProps = createSelector(
  selectIdVerificationResult,
  selectIdVerificationErrorMessage,
  selectDirectorList,
  selectCanVerifyIdUsingPrefilledDetails,
  selectAbn,
  selectHasErroredFromVerifyIdPrefilled,
  selectInvitedStatus,
  selectIsTrust,
  selectTrusteeNames,
  selectMainRegistrationMode,
  selectWorkflowMIsIdVerificationAttemptsMaxed,
  selectShadowRegisteredAccountId,
  selectPEPStatus,
  selectIsPotentialAMLIdentified,
  selectMainPortal,
  selectUserJourneyAccountType,
  selectIsVerifyIdPrefilledError,
  (
    idVerificationResult,
    errorMessage,
    rawDirectorList,
    canVerifyIdUsingPrefilledDetails,
    abn,
    hasErroredFromVerifyIdPrefilled,
    isInvited,
    isTrust,
    trusteeNames,
    registrationMode,
    isIdVerificationAttemptsMaxed,
    shadowRegisteredAccountId,
    pepStatus,
    isPotentialAMLIdentified,
    portalType,
    userJourneyAccountType,
    isVerifyIdPrefilledError,
  ) => {
    let trusteeNamesList = null;
    let directorList = null;

    if (isTrust && trusteeNames[0].firstName && trusteeNames[0].lastName) {
      if (trusteeNames && trusteeNames.length > 0) {
        trusteeNamesList = trusteeNames.map((x) => ({
          id: x,
          text: `${x.firstName} ${x.lastName}`,
        }));
      }
    } else if (rawDirectorList && rawDirectorList.length > 0) {
      directorList = rawDirectorList.map((x) => ({
        id: x,
        text: `${x.firstName} ${x.lastName}`,
      }));

      if (!isInvited) {
        directorList.push(myNameIsNotHere);
      }
    }

    return {
      idVerificationResult,
      errorMessage,
      directorList,
      canVerifyIdUsingPrefilledDetails,
      abn,
      hasErroredFromVerifyIdPrefilled,
      isInvited,
      isTrust,
      trusteeNamesList,
      registrationMode,
      isIdVerificationAttemptsMaxed,
      shadowRegisteredAccountId,
      pepStatus,
      isPotentialAMLIdentified,
      portalType,
      userJourneyAccountType,
      isVerifyIdPrefilledError,
    };
  },
);

function mapDispatchToProps(dispatch) {
  return {
    verifyId: (data) => dispatch(verifyId(data)),
    verifyIdPrefilled: (abn) => dispatch(verifyIdPrefilled(abn)),
    resetVerificationResult: () => dispatch(resetIdVerificationResult()),
    register: (stepLinkHref, callback, errorCallback, verificationDetails) =>
      dispatch(
        registerAccount(
          updateErrorMessage,
          stepLinkHref,
          callback,
          errorCallback,
          verificationDetails,
        ),
      ),
    updateHasErroredFromVerifyIdPrefilled: (isErrored) =>
      dispatch(
        updateHasErroredFromVerifyIdPrefilled(updateHasErroredFromVerifyIdPrefilled(isErrored)),
      ),
    updateIsVerifyIdPrefilledError: (hasError) =>
      dispatch(updateIsVerifyIdPrefilledError(hasError)),
    shadowRegisterAccount: (abn) => dispatch(shadowRegisterAccount(updateErrorMessage, abn)),
    handleIdUploadSuccess: (
      isIdVerificationAttemptsMaxed,
      nameNotListed,
      isPrefilledIdVerified,
      abn,
      idType,
      userJourneyAccountType,
      isIdUploadFail,
    ) =>
      dispatch(
        handleIdUploadSuccess(
          isIdVerificationAttemptsMaxed,
          nameNotListed,
          isPrefilledIdVerified,
          abn,
          idType,
          userJourneyAccountType,
          isIdUploadFail,
          updateErrorMessage,
        ),
      ),
    ssoExistingContact: (abn, data) => dispatch(ssoExistingContact(abn, data, updateErrorMessage)),
    verifySso: (request) => dispatch(verifySso(request, updateErrorMessage)),
    updateCaseContact: (data) => dispatch(updateCaseContact(data, updateErrorMessage)),
    ssoContactPrefilledId: (abn) => dispatch(ssoContactPrefilledId(abn, updateErrorMessage)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IdVerification);
